import { FC, SyntheticEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSwipeable } from 'react-swipeable';

import CaretBtn from '~src/shared/buttons/caretBtn/CaretBtn';
import DaysLeft from '~src/shared/daysLeft/DaysLeft';
import MobileLogoutButton from '~src/shared/buttons/MobileLogoutButton';

import {
  ContentWrapper,
  InfoItems,
  TongueContainer,
  TongueContent,
  TongueTrigger,
  TongueWrapper,
} from './mobileTongue.sc';
import { QuestionsAmount, TimeLeft } from './shared.sc';

interface Props {
  dueDate: string | null;
  name: string;
  surveyLength: number;
}

const MobileTongue: FC<Props> = (props: Props) =>  {

  const [toggled, setToggled] = useState(false);

  const [t] = useTranslation();

  const toggleTongue = (_: SyntheticEvent | null, show?: boolean) => {
    const showing = !show ? !toggled : show;
    setToggled(showing);
    if (showing && document.documentElement) {
      window.scroll({
        top: document.documentElement.scrollHeight,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  const swipeDown = () => {
    toggleTongue(null, false);
  };
  const swipeUp = () => {
    toggleTongue(null, true);
  };

  const handlers = useSwipeable({
    onSwipedUp: swipeUp,
    onSwipedDown: swipeDown,
  });

  return (<div {...handlers} style={{ width: '100%' }}>
      <TongueWrapper $toggled={toggled}>
        <TongueContainer>
          <TongueTrigger onClick={toggleTongue}>
            <CaretBtn size="10px" open={!toggled} caretColor="rgba(255,255,255,0.3)" />
          </TongueTrigger>
          <TongueContent>
            <ContentWrapper>
              <InfoItems>
                <QuestionsAmount>{props.name}</QuestionsAmount>
                <QuestionsAmount>
                  {props.surveyLength}
                  {` ${t('x.questionstream.navbar.questions')}`}
                </QuestionsAmount>
                {props.dueDate && (
                  <TimeLeft>
                    <DaysLeft t={t} withDot date={props.dueDate} />
                  </TimeLeft>
                )}
              </InfoItems>
              <MobileLogoutButton t={t} />
            </ContentWrapper>
          </TongueContent>
        </TongueContainer>
      </TongueWrapper>
    </div>);
}

export default MobileTongue;
